import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

declare var gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private trackingId = environment.googleAnalyticsTrackingId;

  constructor() {
    gtag('config', this.trackingId);
  }

  public trackPageView(url: string) {
    gtag('config', this.trackingId, {
      page_path: url,
    });
  }

  public eventEmitter(eventName: string) {
    gtag('event', eventName, {
      eventCategory: eventName,
    });
  }
}
